import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import { LOGIN_VALIDATION_SCHEMA } from '../../../utils/schema/password_schema';
import { yupResolver } from '@hookform/resolvers/yup';
import { useAuthHandler } from '../../../hooks';
import { TbBrandGoogle } from 'react-icons/tb';
import { successPopup, warningPopup } from '../../../helpers';
import { useNavigate } from 'react-router-dom';
// import { SERVER_URL } from '@/constants';
// import { GoogleLogin } from '@react-oauth/google';

export const LoginForm = ({ setIsModalOpen }) => {
    const { register, handleSubmit, formState: { errors, isSubmitting } } = useForm({
        resolver: yupResolver(LOGIN_VALIDATION_SCHEMA),
    });
    const { loginWithGoogle, login } = useAuthHandler();
    const [showPassword, setShowPassword] = useState(false);
    const [loading, setLoading] = useState(false);

    const navigate = useNavigate();

    const onSubmit = async (data) => {
        try {
            // Handle form submission
            setLoading(true);
            login(data).then(response => {
                if (response.data.status) {
                    // if (response?.data?.user?.email_verified_at === null) {
                    //     localStorage.clear("data");
                    //     localStorage.clear("token");
                    //     sessionStorage.clear();
                    //     warningPopup("Please verify your email to continue!");
                    //     setLoading(false);
                    //     return;
                    // }

                    successPopup('', "Login Successful!");
                    localStorage.setItem('token', response?.data?.token);
                    localStorage.setItem('data', JSON.stringify(response?.data?.user));
                    setIsModalOpen(false)
                    //  navigate to profile if not complete profile
                    setTimeout(() => {
                        if (response?.data?.user?.profile_completeness < 100) {
                            navigate('/profile');
                            // window.location.reload();
                        } else if (!response?.data?.user?.payment_customer_id) {
                            navigate('/account-settings/payments');
                            window.location.reload();
                        } else {
                            window.location.reload();
                        }
                    }, 2000);
                }
            });
        } catch (ex) {
            console.log(ex)
            // errorPopup('', ex.response?.data?.message)

            setLoading(false);
        } finally {
            setLoading(false);
        }
    };

    const togglePassword = () => {
        setShowPassword(show => !show);
    }

    // async function handleCredentialResponse(response) {
    //     console.log("Google Token:", response.credential);

    //     // Send token to Laravel backend
    //     const res = await fetch(`${SERVER_URL}/auth/google/callback?token=${response.credential}`, {
    //         method: "GET",
    //         headers: {
    //             "Content-Type": "application/json"
    //         }
    //     });

    //     const data = await res.json();
    //     console.log(data);

    //     if (data.status) {
    //         localStorage.setItem("token", data.token);
    //         alert("Login Successful!");
    //     } else {
    //         alert("Login Failed!");
    //     }
    // }

    return (
        <>
            <div className="w-full max-w-md mx-auto">
                <h4 className="text-lg font-semibold text-center">Log in</h4>
                <div className="grid gap-4">

                    {/* <div id="g_id_onload"
                        data-client_id="270481183230-gmj62pl2rjnrfn61m6kogdil1m0jpgou.apps.googleusercontent.com"
                        data-callback="handleCredentialResponse"
                        data-auto_prompt="false">
                    </div>

                    <div class="g_id_signin"
                        data-type="standard"
                        data-size="large"
                        data-theme="outline"
                        data-text="sign_in_with"
                        data-shape="rectangular"
                        data-logo_alignment="left">
                    </div> */}

                    {/* <GoogleLogin /> */}
                    <button
                        // disabled
                        className="flex items-center justify-center w-full px-4 py-3 bg-gray-100 rounded-lg shadow-md hover:bg-gray-200"
                        onClick={() => loginWithGoogle()}
                    >
                        <TbBrandGoogle className="w-6 h-6 mr-2" />
                        Log in with Google
                    </button>
                    <div className="flex justify-center">
                        <h3 className="text-sm text-gray-700">OR</h3>
                    </div>
                    <div className="relative flex justify-center">
                        <div className="absolute inset-0 flex items-center justify-between">
                            <div className="w-1/3 h-px bg-gray-300"></div>
                            <div className="w-1/3 h-px bg-gray-300"></div>
                        </div>
                    </div>
                    <div className="flex flex-col gap-4">
                        <form onSubmit={handleSubmit(onSubmit)} className="flex flex-col gap-4">
                            <div>
                                <label className="text-sm font-bold text-gray-700" htmlFor="email">
                                    Username or Email Address <span className="text-red-500">*</span>
                                </label>
                                <input
                                    id="email"
                                    type="text"
                                    {...register('email', { required: 'Email is required' })}
                                    className="w-full px-3 py-2 leading-tight text-gray-700 border rounded shadow appearance-none focus:outline-none focus:shadow-outline"
                                />
                                {errors.email && <p className="text-xs italic text-red-500">{errors.email.message}</p>}
                            </div>
                            <div>
                                <label className="text-gray-700 text-sm font-bold !static !float-none" htmlFor="password">
                                    Password <span className="text-red-500">*</span>
                                </label>
                                <div className="relative flex items-center">
                                    <input
                                        id="password"
                                        type={showPassword ? 'text' : 'password'}
                                        {...register('password', { required: 'Password is required' })}
                                        className="w-full px-3 py-2 leading-tight text-gray-700 border rounded-l shadow appearance-none focus:outline-none focus:shadow-outline"
                                    />
                                    <span
                                        className="absolute inset-y-0 right-0 z-10 flex items-center pr-3 text-sm leading-5 cursor-pointer"
                                        onClick={togglePassword}
                                    >
                                        {showPassword ? <FaEyeSlash /> : <FaEye />}
                                    </span>
                                </div>
                                {errors.password && <p className="text-xs italic text-red-500">{errors.password.message}</p>}
                            </div>
                            <div className="flex items-center">
                                <input
                                    id="remember"
                                    type="checkbox"
                                    className="text-indigo-600 transition duration-150 ease-in-out form-checkbox"
                                />
                                <label htmlFor="remember" className="ml-2 block text-sm leading-5 text-gray-900 !m-0 !ms-1">
                                    Remember me
                                </label>
                            </div>
                            <div>
                                <button
                                    type="submit"
                                    className="bg-[#8EC639] text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline w-full"
                                    disabled={isSubmitting}
                                >
                                    {loading || isSubmitting ?
                                        'Please Wait...!'
                                        : 'Login'}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>


        </>
    )
}
